/* High5Shop – tilbudslandingsside (quiz). Hører til sections/h5-tilbud-landing.liquid */
(function () {
  'use strict';

  document.querySelectorAll('[data-h5l]').forEach(init);

  function init(root) {
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-h5l-config]').textContent); } catch (e) {}

    var params = new URLSearchParams(location.search);
    var SEGMENTS = { firma: 'firma', virksomhed: 'firma', klub: 'klub', sport: 'klub', forening: 'klub', skole: 'skole', event: 'event' };
    var seg = SEGMENTS[(params.get('seg') || '').toLowerCase()] || '';
    var variant = (params.get('v') || 'a').toLowerCase() === 'b' && cfg.headlines && cfg.headlines.b ? 'b' : 'a';
    var testMode = !!cfg.testMode || !!cfg.designMode || params.has('h5test') ||
      /^(127\.0\.0\.1|localhost)$/.test(location.hostname);

    var quiz = root.querySelector('[data-h5l-quiz]');
    var steps = {};
    quiz.querySelectorAll('[data-step]').forEach(function (el) { steps[el.dataset.step] = el; });

    var state = {
      hvem: null, typer: new Map(),
      behov: new Map(), antal: null, metode: new Map(), deadline: null
    };
    var history = [];
    var current = 'typer';
    var tracked = {};

    /* ---------- Overskrift pr. segment / A/B ---------- */
    applyHeadline();
    function applyHeadline() {
      var h = cfg.headlines || {};
      var headline = (seg && h[seg]) || (variant === 'b' && h.b) || h['default'];
      if (!headline) return;
      root.querySelectorAll('[data-h5l-headline]').forEach(function (el) {
        el.textContent = String(headline).replace(/[\[\]]/g, '');
      });
    }

    /* Målgruppe kommer kun fra annoncen (?seg=) – der er intet "Hvem er I?"-trin */
    var SEG_LABELS = { firma: 'Virksomhed', klub: 'Sportsklub eller forening', skole: 'Skole eller uddannelse', event: 'Event eller arrangement' };
    if (seg) state.hvem = { value: seg, label: SEG_LABELS[seg] };

    /* ---------- Rækkefølge ---------- */
    function path() {
      var p = ['typer', 'behov', 'antal'];
      // Tryk/broderi pr. produkttype – springes over, hvis kunden kun har valgt "Ved ikke"
      if (concreteTypes().length) p.push('metode');
      return p.concat(['deadline', 'kontakt']);
    }

    function show(name, opts) {
      opts = opts || {};
      var p = path();
      Object.keys(steps).forEach(function (k) { steps[k].classList.remove('is-active'); });
      steps[name].classList.add('is-active');
      current = name;
      var idx = p.indexOf(name);
      var done = name === 'tak';
      renderDots(done ? p.length : idx, p.length);
      if (name === 'metode') buildMethods();
      if (name === 'kontakt') prepareContact();
      updateFoot();
      // Fast placering: hvert trin starter øverst (desktop scroller kun quiz-kolonnen)
      var main = quiz.closest('.h5l-main');
      if (main && main.scrollHeight > main.clientHeight && main.scrollTop > 0) main.scrollTop = 0;
      if (opts.scroll !== false && quiz.getBoundingClientRect().top < 0) {
        quiz.scrollIntoView({ block: 'start' });
      }
      track(name, idx + 1);
    }

    function next() {
      var p = path();
      var to = p[p.indexOf(current) + 1];
      if (!to) return;
      history.push(current);
      show(to);
    }

    /* ---------- Fast bundlinje: Tilbage + Næste ---------- */
    var foot = quiz.querySelector('[data-h5l-foot]');
    var backBtn = quiz.querySelector('[data-h5l-back]');
    var nextBtn = quiz.querySelector('[data-h5l-next]');
    var MULTI = { typer: 1, behov: 1 };
    function updateFoot() {
      var done = current === 'tak';
      foot.hidden = done;
      // visibility i stedet for display, så knapperne altid står samme sted
      backBtn.style.visibility = history.length ? 'visible' : 'hidden';
      if (current === 'kontakt') {
        nextBtn.style.visibility = 'visible';
        nextBtn.disabled = false;
        nextBtn.textContent = nextBtn.dataset.submitLabel || 'Send';
      } else if (current === 'metode') {
        nextBtn.style.visibility = 'visible';
        nextBtn.disabled = !allMethodsChosen();
        nextBtn.textContent = 'Næste';
      } else if (MULTI[current]) {
        nextBtn.style.visibility = 'visible';
        nextBtn.disabled = state[current].size === 0;
        nextBtn.textContent = 'Næste';
      } else {
        nextBtn.style.visibility = 'hidden';
        nextBtn.textContent = 'Næste';
      }
    }
    backBtn.addEventListener('click', function () {
      if (!history.length) return;
      show(history.pop());
    });
    nextBtn.addEventListener('click', function () {
      if (current === 'kontakt') { form.requestSubmit(); return; }
      next();
    });

    /* ---------- Valg ---------- */
    var SINGLE = { antal: 1, deadline: 1 };
    quiz.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-field]');
      if (!btn || !quiz.contains(btn)) return;
      var field = btn.dataset.field;
      var item = { value: btn.dataset.value, label: btn.dataset.label };

      if (SINGLE[field]) {
        btn.parentElement.querySelectorAll('[data-field]').forEach(function (b) { b.classList.remove('is-selected'); });
        select(btn);
        state[field] = item;
        setTimeout(next, 180);
        return;
      }

      // Multi-valg
      var map = state[field];
      if (map.has(item.value)) { map.delete(item.value); btn.classList.remove('is-selected'); }
      else { map.set(item.value, item); select(btn); }

      // "Ved ikke" udelukker konkrete typer og omvendt
      if (field === 'typer') {
        if (item.value === 'ved-ikke' && map.has('ved-ikke')) {
          map.forEach(function (_, k) { if (k !== 'ved-ikke') map.delete(k); });
          steps.typer.querySelectorAll('[data-field="typer"]:not([data-value="ved-ikke"])').forEach(function (b) { b.classList.remove('is-selected'); });
        } else if (item.value !== 'ved-ikke' && map.has('ved-ikke')) {
          map.delete('ved-ikke');
          steps.typer.querySelector('[data-value="ved-ikke"]').classList.remove('is-selected');
        }
      }
      refreshNext(field);
    });

    function select(btn) { btn.classList.add('is-selected'); }

    /* ---------- Progress-prikker ---------- */
    var dots = quiz.querySelector('[data-h5l-dots]');
    function renderDots(idx, total) {
      if (dots.children.length !== total) {
        var html = '';
        for (var n = 1; n <= total; n++) html += '<i>' + n + '</i>';
        dots.innerHTML = html;
      }
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.className = i < idx ? 'is-done' : i === idx ? 'is-current' : '';
      });
    }

    /* ---------- Tryk/broderi pr. produkttype ---------- */
    var METHOD_LABEL = { tryk: 'Tryk', broderi: 'Broderi', raadgiv: 'Rådgiv os' };
    var methodsBox = quiz.querySelector('[data-h5l-methods]');

    function concreteTypes() {
      // I samme rækkefølge som fliserne; "Ved ikke" tæller ikke
      return Array.prototype.filter.call(steps.typer.querySelectorAll('.h5l-tile[data-field="typer"]'), function (t) {
        return t.dataset.value !== 'ved-ikke' && state.typer.has(t.dataset.value);
      });
    }

    function buildMethods() {
      var tiles = concreteTypes();
      var keep = {};
      var html = '';
      tiles.forEach(function (t) {
        var id = t.dataset.value, lock = t.dataset.metode === 'tryk' || t.dataset.metode === 'broderi' ? t.dataset.metode : '';
        keep[id] = 1;
        var cur = state.metode.get(id);
        if (lock) state.metode.set(id, { label: t.dataset.label, value: lock, valueLabel: METHOD_LABEL[lock], locked: true });
        else if (cur && cur.locked) state.metode.delete(id);
        var img = t.querySelector('img');
        var src = img ? (img.currentSrc || img.src) : '';
        html += '<div class="h5l-method' + (lock ? ' is-locked' : '') + '" data-type="' + escapeHtml(id) + '">' +
          '<span class="h5l-method__type">' + (src ? '<img src="' + escapeHtml(src) + '" alt="">' : '') +
            '<span class="h5l-method__name">' + escapeHtml(t.dataset.label) + '</span></span>' +
          '<span class="h5l-method__choice">' +
            ['tryk', 'broderi'].map(function (v) {
              var disabled = lock && lock !== v;
              return '<button type="button" class="h5l-seg" data-method-type="' + escapeHtml(id) + '" data-method-value="' + v + '"' + (disabled ? ' disabled' : '') + '>' + METHOD_LABEL[v] + '</button>';
            }).join('') +
          '</span></div>';
      });
      // Fjern valg for typer, der ikke længere er valgt
      state.metode.forEach(function (_, k) { if (!keep[k]) state.metode.delete(k); });
      methodsBox.innerHTML = html;
      // Rådgiv-genvejen giver kun mening, hvis mindst én type er åben
      quiz.querySelector('[data-h5l-methods-advise]').hidden = tiles.every(function (t) { return t.dataset.metode === 'tryk' || t.dataset.metode === 'broderi'; });
      paintMethods();
    }

    function paintMethods() {
      methodsBox.querySelectorAll('.h5l-seg').forEach(function (b) {
        var m = state.metode.get(b.dataset.methodType);
        b.classList.toggle('is-selected', !!m && m.value === b.dataset.methodValue);
      });
      methodsBox.querySelectorAll('.h5l-method').forEach(function (row) {
        var m = state.metode.get(row.dataset.type);
        row.classList.toggle('is-advise', !!m && m.value === 'raadgiv');
      });
      updateFoot();
    }

    function allMethodsChosen() {
      var tiles = concreteTypes();
      return tiles.length > 0 && tiles.every(function (t) { return state.metode.has(t.dataset.value); });
    }

    methodsBox.addEventListener('click', function (e) {
      var b = e.target.closest('[data-method-value]');
      if (!b || b.disabled) return;
      var id = b.dataset.methodType;
      var tile = steps.typer.querySelector('.h5l-tile[data-value="' + id + '"]');
      state.metode.set(id, { label: tile ? tile.dataset.label : id, value: b.dataset.methodValue, valueLabel: METHOD_LABEL[b.dataset.methodValue], locked: false });
      paintMethods();
    });

    quiz.querySelector('[data-h5l-methods-advise]').addEventListener('click', function () {
      concreteTypes().forEach(function (t) {
        var m = state.metode.get(t.dataset.value);
        if (m && m.locked) return;
        state.metode.set(t.dataset.value, { label: t.dataset.label, value: 'raadgiv', valueLabel: METHOD_LABEL.raadgiv, locked: false });
      });
      paintMethods();
      next();
    });

    /* ---------- Marquee: kopiér logoer, til de fylder bredden, og dupliker til sømløs løkke ---------- */
    root.querySelectorAll('[data-h5l-marquee]').forEach(function (m) {
      var viewport = m.querySelector('.h5l-marquee__viewport');
      var track = m.querySelector('.h5l-marquee__track');
      var group = track.querySelector('.h5l-marquee__group');
      var originals = Array.prototype.slice.call(group.children);
      function fill() {
        track.querySelectorAll('.h5l-marquee__group[data-clone]').forEach(function (g) { g.remove(); });
        group.querySelectorAll('[data-clone]').forEach(function (c) { c.remove(); });
        var guard = 0;
        while (group.offsetWidth < viewport.offsetWidth && guard++ < 30) {
          originals.forEach(function (o) {
            var c = o.cloneNode(true); c.setAttribute('data-clone', ''); c.setAttribute('aria-hidden', 'true'); group.appendChild(c);
          });
        }
        var dup = group.cloneNode(true); dup.setAttribute('data-clone', ''); dup.setAttribute('aria-hidden', 'true');
        track.appendChild(dup);
        // Konstant fart uanset skærmbredde (~50 px/sek)
        track.style.setProperty('--h5l-marquee-duration', Math.max(group.offsetWidth / 50, 10) + 's');
      }
      fill();
      window.addEventListener('load', fill);
      var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fill, 200); });
    });

    function refreshNext() { updateFoot(); }

    /* ---------- Kontakt ---------- */
    var form = quiz.querySelector('[data-h5l-form]');
    var COMPANY_LABEL = { firma: 'Virksomhed', klub: 'Klub eller forening', skole: 'Skole eller uddannelse', event: 'Virksomhed eller arrangør', andet: 'Virksomhed eller organisation' };
    function prepareContact() {
      var label = state.hvem ? COMPANY_LABEL[state.hvem.value] : 'Virksomhed, klub eller skole';
      quiz.querySelector('[data-h5l-company-label]').textContent = label || 'Virksomhed';
    }

    var fileInput = form.querySelector('[data-h5l-file]');
    fileInput.addEventListener('change', function () {
      var f = fileInput.files[0];
      var wrap = fileInput.closest('.h5l-file');
      var label = form.querySelector('[data-h5l-file-label]');
      if (f && f.size > 15 * 1024 * 1024) {
        fileInput.value = ''; showError('Filen er for stor (maks. 15 MB). Send den gerne på mail i stedet.');
        f = null;
      }
      wrap.classList.toggle('has-file', !!f);
      label.textContent = f ? f.name : 'Upload fil (png, jpg, svg, pdf, ai)';
    });

    form.addEventListener('input', function (e) {
      var fld = e.target.closest('.h5l-field');
      if (fld) fld.classList.remove('is-invalid');
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = Object.fromEntries(new FormData(form).entries());
      var bad = [];
      ['name', 'email', 'phone'].forEach(function (k) { if (!String(data[k] || '').trim()) bad.push(k); });
      if (data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(data.email.trim())) bad.push('email');
      if (data.phone && String(data.phone).replace(/\D/g, '').length < 8) bad.push('phone');
      if (data.cvr && !/^\d{8}$/.test(String(data.cvr).replace(/\s/g, ''))) bad.push('cvr');
      form.querySelectorAll('.h5l-field').forEach(function (f) { f.classList.remove('is-invalid'); });
      if (bad.length) {
        bad.forEach(function (k) { var i = form.elements[k]; if (i) i.closest('.h5l-field').classList.add('is-invalid'); });
        showError(bad.indexOf('cvr') !== -1 && bad.length === 1 ? 'CVR skal være 8 cifre (eller lad feltet stå tomt).' : 'Udfyld venligst de markerede felter.');
        var first = form.elements[bad[0]]; if (first) first.focus();
        return;
      }
      showError('');
      nextBtn.disabled = true; nextBtn.textContent = 'Sender…';
      submitLead(data, fileInput.files[0]).then(function () {
        quiz.querySelector('[data-h5l-firstname]').textContent = firstName(data.name);
        history = [];
        show('tak');
        root.classList.add('is-done');
      });
    });

    function showError(msg) {
      var el = form.querySelector('[data-h5l-error]');
      el.textContent = msg; el.hidden = !msg;
    }

    /* ---------- Afsendelse ---------- */
    function submitLead(d, file) {
      var list = function (m) { return Array.from(m.values()).map(function (x) { return x.label; }); };
      var utm = {};
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'].forEach(function (k) { if (params.get(k)) utm[k] = params.get(k); });
      var marketing = d.marketing === '1';
      var names = splitName(d.name);

      var lead = {
        source: 'high5shop-landingsside',
        name: d.name.trim(),
        firstName: names[0],
        lastName: names[1],
        email: d.email.trim(),
        phone: d.phone.trim(),
        company: d.company.trim(),
        cvr: (d.cvr || '').replace(/\s/g, ''),
        hvem: state.hvem ? state.hvem.label : '',
        produkttyper: list(state.typer).join(', '),
        anvendelse: list(state.behov).join(', '),
        antal: state.antal ? state.antal.label : '',
        metode: concreteTypes().map(function (t) { return state.metode.get(t.dataset.value); }).filter(Boolean).map(function (m) { return m.label + ': ' + m.valueLabel; }).join(', '),
        deadline: state.deadline ? state.deadline.label : '',
        besked: (d.message || '').trim(),
        logoFil: file ? file.name : '',
        markedsfoering: marketing ? 'Ja' : 'Nej',
        segment: seg || '',
        variant: variant,
        side: location.origin + location.pathname,
        notifyEmails: cfg.notifyEmails || '',
        tidspunkt: new Date().toISOString()
      };
      Object.keys(utm).forEach(function (k) { lead[k] = utm[k]; });
      lead.opsummering = summary(lead);

      trackLead(lead);

      if (testMode) {
        console.info('[H5 landingsside] TESTTILSTAND – intet sendt.', lead, file || '(ingen fil)');
        return delay(600);
      }

      var jobs = [];

      // 1) Zapier – High5-notifikation + bekræftelsesmail til leadet
      if (cfg.zapierUrl) {
        jobs.push(fetch(cfg.zapierUrl, { method: 'POST', body: new URLSearchParams(lead) }));
      }

      // 2) GoHighLevel – SMS-bekræftelse (samme felter som tilbudskurven + quiz-svar)
      if (cfg.ghlUrl) {
        var ghl = Object.assign({}, lead, {
          companyName: lead.company,
          message: lead.opsummering,
          newsletter: lead.markedsfoering
        });
        jobs.push(fetch(cfg.ghlUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(ghl) }));
      }

      // 3) Tilbudsloggen (gemmer alt + videresender til Make)
      if (cfg.tilbudslogUrl) {
        var fd = new FormData();
        fd.append('quote_number', 'LP-' + Date.now().toString().slice(-8));
        fd.append('date', new Date().toLocaleDateString('da-DK'));
        fd.append('customer_name', lead.name);
        fd.append('customer_email', lead.email);
        fd.append('customer_company', lead.company + (lead.cvr ? ' (CVR ' + lead.cvr + ')' : ''));
        fd.append('customer_phone', lead.phone);
        fd.append('customer_message', lead.opsummering);
        fd.append('total_incl_vat', '');
        var types = Array.from(state.typer.values());
        fd.append('total_items', String(types.length));
        fd.append('source', lead.source);
        // Produkttyper som linjer (ingen konkrete varianter – dem aftaler phoneren)
        fd.append('items_json', JSON.stringify(types.map(function (t) {
          var m = state.metode.get(t.value);
          return { title: t.label, color: '', branding: m ? m.valueLabel : '', quantity: 0, discount: 0, pricePerUnit: 0, lineTotal: '', variantId: '' };
        })));
        if (file) { fd.append('logo_file_0', file, file.name); }
        fd.append('logo_file_count', file ? '1' : '0');
        jobs.push(fetch(cfg.tilbudslogUrl, { method: 'POST', body: fd }));
      }

      // 4) Shopifys kontaktformular (mail til butikken)
      if (cfg.sendShopifyMail) {
        var cf = new FormData();
        cf.append('form_type', 'contact');
        cf.append('utf8', '✓');
        cf.append('contact[name]', lead.name);
        cf.append('contact[email]', lead.email);
        cf.append('contact[phone]', lead.phone);
        cf.append('contact[body]', 'TILBUDSFORESPØRGSEL (landingsside)\n\n' + lead.opsummering);
        jobs.push(fetch('/contact#contact_form', { method: 'POST', body: cf, headers: { Accept: 'application/json' } }));
      }

      // 5) Kun ved samtykke: opret kunde i Shopify med markedsføringstilladelse
      if (marketing) {
        var cu = new FormData();
        cu.append('form_type', 'customer');
        cu.append('utf8', '✓');
        cu.append('contact[email]', lead.email);
        cu.append('contact[first_name]', lead.firstName);
        cu.append('contact[last_name]', lead.lastName);
        cu.append('contact[tags]', 'newsletter,landingsside-tilbud');
        jobs.push(fetch('/contact#contact_form', { method: 'POST', body: cu, headers: { Accept: 'application/json' } }));
      }

      // Vent højst 4 sek. – kunden skal ikke sidde og vente på webhooks
      var all = Promise.all(jobs.map(function (j) { return j.catch(function (err) { console.warn('[H5 landingsside]', err); }); }));
      return Promise.race([all, delay(4000)]);
    }

    function summary(l) {
      var rows = [
        ['Navn', l.name], ['Virksomhed/klub', l.company], ['CVR', l.cvr], ['E-mail', l.email], ['Telefon', l.phone],
        ['Hvem', l.hvem], ['Produkttyper', l.produkttyper],
        ['Anvendelse', l.anvendelse], ['Antal', l.antal], ['Tryk/broderi', l.metode],
        ['Deadline', l.deadline], ['Logo-fil', l.logoFil], ['Besked', l.besked], ['Markedsføring', l.markedsfoering],
        ['Kampagne', [l.segment, l.variant !== 'a' ? 'variant ' + l.variant : '', l.utm_campaign].filter(Boolean).join(' · ')]
      ];
      var txt = rows.filter(function (r) { return r[1]; }).map(function (r) { return r[0] + ': ' + r[1]; }).join('\n');
      return txt;
    }

    /* ---------- Måling ---------- */
    function publish(name, data) {
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
    }
    // Meta-pixlen indlæses asynkront af Shopify – vent op til ~5 sek. på den, så første trin ikke går tabt
    function fbqSend() {
      var args = arguments, tries = 0;
      (function attempt() {
        if (window.fbq) { window.fbq.apply(window, args); return; }
        if (++tries < 20) setTimeout(attempt, 250);
      })();
    }
    function track(step, n) {
      if (tracked[step]) return;
      tracked[step] = 1;
      var data = { step: step, step_number: n, segment: seg || (state.hvem && state.hvem.value) || '', variant: variant };
      // Testtilstand: intet sendes til Meta/Shopify – ellers forurener test-klik annoncedataene
      if (testMode) { console.info('[H5 landingsside] step (ikke sendt – testtilstand)', data); return; }
      publish('h5_tilbud_step', data);
      fbqSend('trackCustom', 'QuizStep', data);
    }
    function trackLead(lead) {
      var data = {
        segment: lead.segment || (state.hvem && state.hvem.value) || '', variant: lead.variant,
        antal: lead.antal, produkttyper: lead.produkttyper,
        email: lead.email, phone: lead.phone, first_name: lead.firstName, last_name: lead.lastName
      };
      if (testMode) { console.info('[H5 landingsside] Lead (ikke sendt – testtilstand)'); return; }
      publish('h5_tilbud_lead', data);
      fbqSend('track', 'Lead', { content_name: 'Tilbud landingsside', segment: data.segment, variant: data.variant });
    }

    /* ---------- Kategori-fliser og CTA'er ---------- */
    root.querySelectorAll('[data-h5l-pick-type]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var id = a.dataset.h5lPickType;
        var tile = steps.typer.querySelector('[data-value="' + id + '"]');
        if (tile && !state.typer.has(id)) {
          state.typer.set(id, { value: id, label: tile.dataset.label });
          select(tile);
          if (state.typer.has('ved-ikke')) { state.typer.delete('ved-ikke'); steps.typer.querySelector('[data-value="ved-ikke"]').classList.remove('is-selected'); }
        }
        refreshNext('typer');
        quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    root.querySelectorAll('[data-h5l-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        quiz.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    var sticky = root.querySelector('[data-h5l-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var inView = entries[0].isIntersecting;
        var pastHero = quiz.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-visible', !inView && pastHero && !root.classList.contains('is-done'));
      }).observe(quiz);
    }

    /* ---------- Start ---------- */
    show(current, { scroll: false });
  }

  /* ---------- Hjælpere ---------- */
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function splitName(n) { var p = String(n || '').trim().split(/\s+/); return [p.shift() || '', p.join(' ')]; }
  function firstName(n) { return splitName(n)[0]; }
  function delay(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
})();
